export interface IEgSupportedSubject {
  code: string;
  displayName: string;
  grades: number[];
  imageGenerationEnabled: boolean;
}

export interface IEgSupportedConfig {
  subjects: IEgSupportedSubject[];
}

// Enums for User Generated Exam Generator
export enum ExamSubject {
  English = 'Eng',
  Urdu = 'Urdu',
  Maths = 'Maths',
  Islamiyat = 'Islamiat',
  Science = 'Science',
  GeneralKnowledge = 'GenK',
  SocialStudies = 'SST',
}

export enum QuestionCategory {
  Seen = 'seen',
  Unseen = 'unseen',
}

export enum UGExamQuestionType {
  Objective = 'objective',
  Subjective = 'subjective',
}

export enum ExamStatus {
  Pending = 'pending',
  Ready = 'ready',
  Error = 'error',
}

export interface IExamQuestionPath {
  category: QuestionCategory;
  type: UGExamQuestionType;
  formatType: string;
  index: number;
}

// Backend question interface
export interface IBackendQuestion {
  lines: number;
  marks: number;
  blooms?: string;
  question?: string;
  main_question?: string;
  options?: string[];
  words?: string[];
  column_a?: string[];
  column_b?: string[];
  passage?: string;
  section?: string;
  image?: string;
  questions?: Array<{
    lines: number;
    marks: number;
    question: string;
  }>;
}

// Narrowed question types for objective/subjective sections
export interface IObjectiveQuestion extends IBackendQuestion {
  question: string;
  options: string[];
  marks: number;
  lines: number;
}

export interface ISubjectiveQuestion extends IBackendQuestion {
  question: string;
  marks: number;
  lines: number;
}

// Typed map of format-key → question array
// Named keys provide IDE autocomplete; index signature allows arbitrary format keys
export interface IQuestionsByType {
  MCQs?: IObjectiveQuestion[];
  MSQs?: IObjectiveQuestion[];
  'True/False'?: IObjectiveQuestion[];
  'Match the Column'?: IObjectiveQuestion[];
  'Fill in the Blanks'?: IObjectiveQuestion[];
  'Brief Answers'?: ISubjectiveQuestion[];
  'Long Questions'?: ISubjectiveQuestion[];
  'Mind Map'?: ISubjectiveQuestion[];
  Other?: ISubjectiveQuestion[];
  [key: string]: IObjectiveQuestion[] | ISubjectiveQuestion[] | undefined;
}

// Typed alias for the full nested exam JSON structure
export interface IExamJsonStructure {
  seen?: {
    objective?: IQuestionsByType;
    subjective?: IQuestionsByType;
  };
  unseen?: {
    objective?: IQuestionsByType;
    subjective?: IQuestionsByType;
  };
}

// Backend response interface (nested structure)
export type IBackendExamJson = IExamJsonStructure;

// Backend API response interface
export interface IBackendGeneratedExam {
  id: string;
  status: ExamStatus;
  examJson: IBackendExamJson;
  examHtml: string;
  tags: {
    grade: number;
    subject: ExamSubject;
    pageRanges: string;
    questionTypes: QuestionCategory[];
    seenCategories?: UGExamQuestionType[] | null;
    unseenCategories?: UGExamQuestionType[] | null;
    unseenObjectiveTypes?: string[] | null;
    unseenSubjectiveTypes?: string[] | null;
    examType?: string;
    selectedChapters?: number[];
    imageGenerationEnabled?: boolean;
  };
  metadata: Record<string, any>;
  created: string;
  modified: string;
  selectedQuestionIds?: string[] | null;
}
